define('gigaset_recurring/components/customer/subscription/provider/billwerk/view',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"lucid",
	"cartware/components/PubSubHub",
	"cartware/jquery/bem",
	"cartware/components/Config",
	"gigaset_recurring/classes/provider/billwerk/loader",
	"text!shoptheme/templates/magnific-popup/default.html",
	"gigaset_recurring/classes/provider/billwerk/steps/payment",
	"magnific-popup"
], function(
	$,
	_,
	Component,
	lucidJS,
	PubSubHub,
	BEM,
	Config,
	BillwerkLoader,
	PopupHtml,
	PaymentStep
) {
	var popupTemplate = null;

	return Component.create(_.create(new lucidJS.EventEmitter, {
		billwerk:			null,
		portal:				null,
		authCheckUrl:		null,
		paymentService:		null,

		paymentStep:		null,

		cancelSubscriptionBlock:	null,
		finalizeBlock:		null,

		agreementsBlock:		null,
		agreementState:			null,

		paymentChangeNeedsRebind: false,

		constructor: function() {
			lucidJS.EventEmitter.call(this);
		},

		init: function() {
			this.billwerk = {
				initialized:			false,
				pubKey:					Config.get('recurring.provider.billwerk.api.public_key'),
				returnUrl:				Config.get('recurring.provider.billwerk.provider.url.return'),
				selfServiceToken:		Config.get('recurring.provider.billwerk.contract.self_service_token.token'),
				trigger: {
					finalize:				Config.get('recurring.provider.billwerk.trigger.finalize')
				},
				createOrderUrl:			Config.get('recurring.provider.billwerk.provider.url.createOrder'),
				upgradeUrl:				Config.get('recurring.provider.billwerk.provider.url.upgrade'),
				contract: 				Config.get('recurring.provider.billwerk.contract')
			};

			this.authCheckUrl =	Config.get('recurring.check_auth_url');

			BillwerkLoader.once("loaded", _.bind(this.onBillwerkJs, this));
			BillwerkLoader.load();
		},

		$init: function() {
			this.block = BEM.block("gigaset-recurring-contract-details");
			this.cancelSubscriptionBlock = BEM.block("gigaset-recurring-contract-cancel-confirm");
			this.cancellationConfirmedBlock = BEM.block("gigaset-recurring-contract-cancellation-confirmed");
			this.prolongSubscriptionBlock = BEM.block("gigaset-recurring-contract-prolong");
			this.prolongationConfirmedBlock = BEM.block("gigaset-recurring-contract-prolongation-confirmed");
			this.agreementsBlock = BEM.block("gigaset-recurring-contract-agreements");

			this.agreementState = this.getCheckboxState();

			// Not prerendered
			this.openFinalizeBlockInModal = BEM.block("gigaset-recurring-payment-finalize").length === 0;

			this.bindEvents();
		},

		bindEvents: function() {
			var self = this;

			this.block.on("click", "[data-onclick=changePayment]", _.bind(this.changePayment, this));
			this.block.on("click", "[data-onclick=cancelSubscription]", _.bind(this.cancelSubscription, this));
			this.block.on("click", "[data-onclick=prolongSubscription]", _.bind(this.prolongSubscription, this));

			this.agreementsBlock.on("change", "[data-onclick=showHideAgreementSaveButton]", _.bind(this.showHideAgreementSaveButton, this));

			this.on("payment.finalizing", _.bind(function() {
				this.insertFinalizeBlock();
				this.finalizeBlock
					.bemRemoveModifier("success")
					.bemRemoveModifier("fail")
					.bemAddModifier("loading");
			}, this));

			this.on("payment.confirm", _.bind(function() {
				this.insertFinalizeBlock();
				this.finalizeBlock
					.bemRemoveModifier("loading")
					.bemRemoveModifier("fail")
					.bemAddModifier("success");
			}, this));

			this.on("payment.fail", _.bind(function() {
				this.insertFinalizeBlock();
				this.finalizeBlock
					.bemRemoveModifier("loading")
					.bemRemoveModifier("success")
					.bemAddModifier("fail");
			}, this));
		},

		onBillwerkInitialized: function() {
			this.billwerk.initialized = true;
			this.initializePaymentStep();

			if (this.billwerk.trigger.finalize) {
				this.finalize();
			}
		},

		onBillwerkInitializationFail: function() {
			this.billwerk.initialized = false;
		},

		onBillwerkJs: function() {
			if (this.billwerk.selfServiceToken) {
				this.portal = new BillwerkJS.Portal(this.billwerk.selfServiceToken);
			}

			this.paymentService = new BillwerkJS.Payment({
					publicApiKey : this.billwerk.pubKey,
					providerReturnUrl : this.billwerk.returnUrl
				},
				_.bind(this.onBillwerkInitialized, this),
				_.bind(this.onBillwerkInitializationFail, this)
			);
		},

		initializePaymentStep: function() {
			var submitting = false,
				self = this;

			this.paymentStep = new PaymentStep;
			this.paymentStep.addData({
				module:			this,
				paymentService:	this.paymentService
			});
			this.paymentStep.initialize();
			this.paymentStep.open();
			this.paymentStep.on("submit", _.bind(function() {
				submitting = true;
				this.paymentStep.proceedButton.button("loading");
			}, this));

			this.paymentStep.on("close", _.bind(function() {
				if (submitting) return;
				_.attempt(function() {
					$.magnificPopup.instance.close();
				});
			}, this));

			this.paymentStep.on("close", _.bind(function() {
				if (!submitting) return;

				var self = this;

				this.loginCheck(function () {
					try {
						self.portal.paymentChange(
							self.paymentService,
							_.clone(self.paymentStep.getFormData("payment")),
							_.bind(function onSuccess() {
								// _.attempt(function() {
								// 	$.magnificPopup.instance.close();
								// });
								self.paymentStep.proceedButton.button("reset");
								self.handlePayment.apply(self, arguments);
							}, self),
							_.bind(function onFailure() {
								self.paymentStep.proceedButton.button("reset");
								_.curryRight(
									_.bind(self.handleError, self),
									self.translate("An error occurred while connecting to the payment service")
								).apply(self, arguments);
							}, self)
						);
					} catch(e) {
						self.paymentStep.proceedButton.button("reset");
						self.emit("payment.fail");
						self.handleError(e);
					}
				})
			}, this));
		},

		changePayment: function() {
			if (!this.billwerk.initialized) {
				return;
			}

			if (this.paymentChangeNeedsRebind) {
				this.paymentStep.bindEvents();
			}

			this.paymentChangeNeedsRebind = 1;


			this.openModal(this.paymentStep.block, {modifier: "mid"});
		},

		prolongSubscription: function() {
			var self = this;

			this.openModal(this.prolongSubscriptionBlock);
			this.prolongSubscriptionBlock.on("submit", "form", function(e) {
				var form = $(this),
					submitButton = form.find("button[type=submit]"),
					validation = form.data('gigaset_recurring/form/validation');

				e.preventDefault();

				if (!validation) {
					validation = new Validation(this);
					form.data('gigaset_recurring/form/validation', validation)
				}

				if (!validation.validate()) {
					return;
				}

				submitButton.button("loading");

				self.loginCheck(function () {
					$.ajax(self.billwerk.upgradeUrl, {
						data: {
							contract: _.get(self.billwerk.contract, 'id')
						}
					}).done(function(data) {
						self.handleProlongation();
					}).fail(function(xhr) {
						var message = _.get(xhr, 'responseJSON.message', self.translate("We are experiencing technical problems. Please try again later."));
						self.handleError(new Error, message);
					});
				})
			});

			this.prolongSubscriptionBlock.on("click", "[data-onclick=cancel]", function() {
				if ($.magnificPopup.instance) {
					$.magnificPopup.instance.close();
				}
			});
		},

		handleProlongation: function() {
			var self = this;

			this.openModal(this.prolongationConfirmedBlock);

			$.magnificPopup.instance.close = _.wrap(
				$.magnificPopup.instance.close,
				function(func) {
					self._reloadPage();
					// func();
					self.prolongationConfirmedBlock.find("[data-onclick=close]").button("loading");
				}
			);

			this.prolongationConfirmedBlock.on("click", "[data-onclick=close]", function() {
				if ($.magnificPopup.instance) {
					$.magnificPopup.instance.close();
				}
			});
		},

		cancelSubscription: function() {
			var self = this;

			this.openModal(this.cancelSubscriptionBlock);
			this.cancelSubscriptionBlock.on("submit", "form", function(e) {
				var form = $(this),
					submitButton = form.find("button[type=submit]"),
					validation = form.data('gigaset_recurring/form/validation');

				e.preventDefault();

				if (!validation) {
					validation = new Validation(this);
					form.data('gigaset_recurring/form/validation', validation)
				}

				if (!validation.validate()) {
					return;
				}

				submitButton.button("loading");

				self.loginCheck(function () {
					self.portal.contractCancel(
						_.bind(self.handleCancellation, self),
						_.curryRight(
							_.bind(self.handleError, self),
							self.translate("An error occurred cancelling your subscription")
						)
					);
				});
			});

			this.cancelSubscriptionBlock.on("click", "[data-onclick=cancel]", function() {
				if ($.magnificPopup.instance) {
					$.magnificPopup.instance.close();
				}
			});
		},

		handleCancellation: function() {
			var self = this;

			this.openModal(this.cancellationConfirmedBlock);

			$.magnificPopup.instance.close = _.wrap(
				$.magnificPopup.instance.close,
				function(func) {
					self._reloadPage();
					// func();
					self.cancellationConfirmedBlock.find("[data-onclick=close]").button("loading");
				}
			);

			this.cancellationConfirmedBlock.on("click", "[data-onclick=close]", function() {
				if ($.magnificPopup.instance) {
					$.magnificPopup.instance.close();
				}
			});
		},

		insertFinalizeBlock: function() {
			var self = this;

			if (null === this.finalizeBlock) {
				this.finalizeBlock = BEM.block("gigaset-recurring-payment-finalize");
				if (!this.finalizeBlock.length) {
					this.finalizeBlock = $(this.block.getElements("template-finalize").html()).filter("*");
					if (!this.openFinalizeBlockInModal) {
						this.block.getElements("details").after(this.finalizeBlock);
					}
				}
			}

			if (this.openFinalizeBlockInModal) {
				this.openModal(this.finalizeBlock);
				$.magnificPopup.instance.close = _.wrap(
					$.magnificPopup.instance.close,
					function (func) {
						self._reloadPage();
					}
				);
			}
		},

		finalize: function() {
			this.logger.info("finalize()");
			this.emit("payment.finalizing");

			BillwerkJS.finalize(
				_.bind(function() {
					console.log(arguments);
					this.handleFinalize.apply(this, arguments);
					this.emit("payment.confirm");
				}, this),
				_.bind(function(error) {
					this.emit("payment.fail");
					this.handleError(new Error, _.get(error, "details") || this.translate("An error occurred while finalizing the payment data"));
					// _.curryRight(
					// 	_.bind(this.handleError, this),
					// 	this.translate("An error occurred while finalizing the payment data")
					// ).apply(this, arguments);
				}, this)
			);
		},

		handlePayment: function(result) {
			this.emit("payment.complete");

			if (!result.Url) {
				this.emit("payment.confirm");
			} else {
				window.location.href = result.Url;
			}
		},

		handleFinalize: function() {
			// TODO
			this.logger.info("handleFinalize()");
		},

		loginCheck: function (callback) {
			var self = this;

			$.ajax({
				url: this.authCheckUrl,
				data: { contractId: this.billwerk.contract.id },
				dataType: 'json',
				success: function (result) {
					if (result.check) {
						callback();
					} else {
						self.openModal(self.translate("Your session expired. Please reload the page."));

						$.magnificPopup.instance.close = _.wrap(
							$.magnificPopup.instance.close,
							function (func) {
								self._reloadPage();
							}
						);
					}
				}
			});
		},

		handleError: function(error, customMessage) {
			var message = "undefined" !== typeof customMessage
				? customMessage
				: _.get(error, "message", this.translate("Unknown error"));

			this.openModal(message);
			this.logger.trace(message, error);
		},

		translate: function(string) {
			return _.isFunction(window.Translator.translate) ? window.Translator.translate(string) : string;
		},

		displayValidationError: function(message) {
			this.openModal(message);
		},

		openModal: function(body, options) {
			var bodyString = body,
				src;

			if (!_.isString(body)) {
				bodyString = '<div class="body___placeholder"></div>';
			}

			src = $(this._renderPopup(_.defaults(options || {}, { body: bodyString })));

			if (!_.isString(body)) {
				src.find(".body___placeholder").replaceWith(body);
			}

			$.magnificPopup.open({
				items: {
					src: src,
					type: 'inline'
				}
			});
		},

		showHideAgreementSaveButton: function() {
			var newState = this.getCheckboxState();
			if (this.agreementState !== newState) {
				this.agreementsBlock.getElements('button').show();
			} else {
				this.agreementsBlock.getElements('button').hide();
			}
		},

		getCheckboxState: function() {
			var state = 1;
			this.agreementsBlock.getElements("checkbox").each(function (key, element) {
				var checkbox = $(element);
				if (checkbox.is(":checked")) {
					var value = checkbox.data("agreement");
					state = state * value + value;
				}
			});

			return state;
		},

		_renderPopup: function(data) {
			if (null === popupTemplate) {
				popupTemplate = _.template(PopupHtml);
			}

			return popupTemplate(data);
		},

		_reloadPage: function() {
			if (_.isFunction(_.get(window, "location.reload"))) {
				window.location.reload(true);
				return;
			}

			location = location;
		}
	}));
});
